import _ from "lodash";

/**
 * Retrieve label error from a GET response
 *
 * Example deafult_val
 * "errors.error_machine_cp_connect"
 *
 * @param {Object} err
 * @param {String} default_val
 */
export const getErrorAlertMessage = function (err, default_val) {
  const lbl = getLabelResponse(err) ? err.response.data.result.label : default_val;
  const msg = (((err.response || false).data || false).result || false).error || false;

  if (lbl) {
    return { message: "", result: { label: "errors." + lbl } };
  } else if (msg) {
    return { message: msg, result: { label: "" } };
  } else return {};
};

export const getLabelResponse = function (res) {
  if (localStorage.getItem("gerErrorResultMessage")) {
    const message = _.get(res, "response.data.result.message", false);
    localStorage.setItem("gerErrorResultMessage", message);
  }
  return (
    _.get(res, "response.data.result.label", false) ||
    _.get(res, "response.data.error.label", false)
  );
};
